<template>
  <div class="mt-2 flex  overflow-hidden flex-grow ">
    <div class="overflow-hidden  flex flex-col pb-4 flex-grow bg-trader-gray ">

      <!--go back  -->
      <div class="w-full  h-10 ">
        <div class="flex items-center justify-center bg-primary w-10 h-full hover:bg-trader-blue" @click="goBack">
          <i class="fa-solid fa-arrow-left text-black text-xl"></i>
        </div>
      </div>

      <!--Bearbeitung Weißer hintergrund  -->
      <div class=" flex-grow overflow-hidden px-10 h-full  flex  text-center justify-center">



        <div class="flex flex-col overflow-auto bg-white rounded p-10  max-w-[1000px] flex-grow">

          <div v-if="fromLogin" class="mb-5 text-trader-market-red text-lg text-left">
            <p class="text-2xl font-bold">
              Bitte vervollständigen Sie Ihre Daten.
            </p>
            Diese Seite wird Ihnen nach der Anmeldung angezeigt, weil leider bisher keine gültige E-Mail-Adresse hinterlegt ist.
          </div>

          <div class="flex items-center justify-between h-10 mb-4 w-full rounded">
            <div class="w-full bg-primary p-2 rounded">
              <span class="text-xl "> Benutzer Übersicht</span>
            </div>
          </div>



          <div class="flex flex-col sm:flex-row w-full">
            <div class="w-full">
              <div class="flex mt-2 text-center w-full">
                <span class="bg-primary w-1/4 p-2 rounded">Name</span>
                <input class="border p-2 rounded w-3/4" v-model="user.name">
              </div>
              <div class="flex mt-2 text-center w-full">
                <span class="bg-primary w-1/4 p-2 rounded">E-Mail</span>
                <input class="border p-2 rounded w-3/4" v-model="user.mail">
              </div>
              <div class="flex mt-2 text-center w-full">
                <span class="bg-primary w-1/4 p-2 rounded">Telefon</span>
                <input class="border p-2 rounded w-3/4" v-model="user.phone">
              </div>
              <button @click="editUser" class="w-full rounded mt-2 p-3 bg-primary hover:bg-trader-green hover:text-white transition duration-200 ease-in-out">Speichern</button>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import {gql} from "@apollo/client/core";
import router from "@/router";
import apolloClient from "@/apolloClient";

export default {
  data() {
    return {
      userId: null,
      showUser: true,
      selectedTeams: [],
      userData: {
        user: [],
      },
      teams: [],
      user: {
        fetchedUser: "",
      },
      loginMessage: false,
      fromLogin: false,
    };
  },

  methods: {
    goBack(){
      router.push(`/project`);
    },
    async editUser() {
      const userData = {
        userID: this.userId,
        name: this.user.name,
        mail: this.user.mail,
        phone: this.user.phone,
      };

      const mutation = gql`
        mutation editUserInformation($user: UserInputInformation!) {
          editUserInformation(user: $user) {
            success
          }
        }
      `;

      try {
        const variables = {
          user: userData
        };
        const {data} = await apolloClient.mutate({mutation, variables});
        //router.push(`/project`);
      } catch (error) {
        console.error("Daten konnten nicht geupdatet werden ", error);
      }
    },
    async getUserInfo() {

      try {
        const response = await apolloClient.query({
          query: gql`
            query getUserInfo {
              getUserInfo {
                userName
                userId
                userMail
                userPhone

              }
            }
          `
        });
        this.user.name = response.data.getUserInfo.userName;
        this.userId = response.data.getUserInfo.userId;
        this.user.mail = response.data.getUserInfo.userMail;
        this.user.phone = response.data.getUserInfo.userPhone;
        this.user.login = response.data.getUserInfo.userName;
        if(this.fromLogin && this.user.mail != null && this.user.mail != ""){
          router.push(`/project`);
        } else {
          this.loginMessage = true;
        }
      } catch (e) {
      }
    },

  },
  mounted() {

    this.getUserInfo();
  },
  watch: {
    '$route.params.userId': function (newId, oldId) {
      this.userId = newId;
    },

    '$route.params': function (newParams, oldParams) {
      this.userId = newParams.userId;
    }
  },
  created() {
    if (this.$isParamDefined('login')) {
      this.fromLogin = this.$route.params.login == 'login';
    }

    if(this.$route.params.userId != null && typeof this.$route.params.userId != 'undefined' && this.$route.params.userId != '' ){
      this.userId = this.$route.params.userId;
      this.getUser();
      this.getTeams();
    }
  }
};
</script>
